import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { ModalInterface } from "app/interface/modal";
import { BehaviorSubject } from 'rxjs';
import { ProfileService } from '@core/services/profile.service';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { NdbxIconModule } from '@allianz/ngx-ndbx/icon';
import { Profile } from '@shared/models/profile';

@Component({
    selector: 'app-cancel-mkt',
    templateUrl: './cancel-mkt.component.html',
    styleUrls: ['./cancel-mkt.component.scss'],
    standalone: false
})
export class CancelMKTComponent implements OnInit, AfterViewInit, ModalInterface {

    @ViewChild('CancelMKT') modalTemplateRef: TemplateRef<any>;
    initiator: BehaviorSubject<boolean> = new BehaviorSubject(false);
    modalDialogRef: NxModalRef<any, any>;
    confirm: BehaviorSubject<SubmitEvent> = new BehaviorSubject(null);

    private profile: Profile | null;

    constructor(
        private dialogService: NxDialogService,
        private profileService: ProfileService,
    ) {
    }

    openModal(): void {
        this.modalDialogRef = this.dialogService.open(this.modalTemplateRef, { showCloseIcon: true });
    }

    closeModal(): void {
        this.modalDialogRef.close();
    }

    ngAfterViewInit(): void {
        this.initiator.next(true);
    }

    ngOnInit(): void {
    }

    inputData(inputData?: any): void {
        if (inputData['profile']) {
            this.profile = inputData['profile'];
        }
    }

    cancelMKT() {
        if(!this.profile){
            return;
        }

        this.profileService.postMKTApprovalCancel(
            this.profile.firstName,
            this.profile.lastName,
            this.profile.personalNumber,
        ).subscribe({
            error: () => {
                this.closeModal();
            },
            next: () => {
                window.location.reload();
            },
        });
    }

}

